import { db } from '@/main'
import BaseModal from '@/components/modals/base'
import ModalWrapper from '@/components/modals/wrapper'
import FeaturedImage from '@/components/featured-image'

export const Sellable = {
  components: {
    BaseModal,
    ModalWrapper,
    FeaturedImage
  },

  props: {
    categories: { type: Array },
    category: { default: 'all' }
  },

  data() {
    return {
      items: [],
      type: 'service',
      collection: 'services',
      show: { new: false, edit: false },
      editable: {},
    }
  },

  firestore() {
    return {
      items: db.collection( this.collection ).where( 'business_id', '==', this.biz.id ).orderBy( 'title' )
    }
  },

  computed: {
    filtered() {
      if ( this.category == 'all' ) return this.items
      else return this.items.filter( item => item.category_id == this.category.id )
    }
  },

  methods: {
    make() {
      this.show.new = true
    },

    remove( doc, collection='services' ) {
      db.collection( collection ).doc( doc.id ).delete()
    },

    edit( doc, collection='services', type='service' ) {
      this.editable = doc
      this.editable_images = []
      db.collection( collection ).doc( doc.id ).collection( 'images' ).get().then( docs =>
        docs.forEach( doc => this.editable_images.push( doc.data() ) )
      )
      this.show.edit = true
    }
  }
}
